module.exports = __webpack_public_path__ + "static/waves-right-3842c3f08fe0c3017fac938aff77513c.png";